import axios from "axios";

export interface IMP4Response {
  status: number;
  data: {
    message: string;
    bufferUrls: string[];
  };
}

export const toMP4 = async (urls: string[]): Promise<IMP4Response> =>
  axios.post("https://mp4.inspecionarcloud.com.br/videos/buffer", {
    urls,
  });
